<template>
	<svg
		width="41"
		height="40"
		viewBox="0 0 41 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.6463 6.25C11.4957 6.25 10.563 7.18274 10.563 8.33333V23.9275C10.9508 23.8098 11.3703 23.75 11.813 23.75H31.3963V6.25H12.6463ZM33.8963 6C33.8963 4.7574 32.889 3.75 31.6463 3.75H12.6463C10.115 3.75 8.06299 5.80203 8.06299 8.33333V32.5C8.06299 33.4347 8.34659 34.385 9.01852 35.1146C9.70596 35.861 10.684 36.25 11.813 36.25H33.8963V6ZM31.3963 26.25H11.813C11.2753 26.25 11.0034 26.4206 10.8575 26.5791C10.6961 26.7543 10.563 27.0541 10.563 27.5C10.563 27.9459 10.6961 28.2457 10.8575 28.4209C11.0034 28.5794 11.2753 28.75 11.813 28.75H31.3963V26.25ZM31.3963 31.25H11.813C11.2753 31.25 11.0034 31.4206 10.8575 31.5791C10.6961 31.7543 10.563 32.0541 10.563 32.5C10.563 32.9459 10.6961 33.2457 10.8575 33.4209C11.0034 33.5794 11.2753 33.75 11.813 33.75H31.3963V31.25ZM14.7297 11.6667C14.7297 10.9763 15.2893 10.4167 15.9797 10.4167H25.9797C26.67 10.4167 27.2297 10.9763 27.2297 11.6667C27.2297 12.357 26.67 12.9167 25.9797 12.9167H15.9797C15.2893 12.9167 14.7297 12.357 14.7297 11.6667Z"
			fill="white"
		/>
	</svg>
</template>
